// custom typefaces
import "@fontsource-variable/montserrat"
import "@fontsource/merriweather"
// normalize CSS across browsers
// import "./src/normalize.css"
import "./src/global.css"
// custom CSS styles
import "./src/style.css"
// Highlighting for code blocks
import "prismjs/themes/prism.css"

// Initialize theme on page load to prevent flash
export const onClientEntry = () => {
  // Get saved theme or default to light
  const savedTheme = localStorage.getItem("theme") || "light"
  document.body.className = savedTheme
}
